/**
 * ResultsTitle
 *
 * Handles the content for the results title in the map
 *
 * @return {view}
 */

OT.createNS('OT.Redesign.Views.Results.Map.ResultsTitle');

OT.Redesign.Views.Results.Map.ResultsTitle = Backbone.ViewManager.BaseView.extend({
    el: '#search_results_map .title',

    template: 'Common/Results/_ResultsTitle'
});
